import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DisplayTeamMemberPipe } from './display-team-member.pipe';

@NgModule({
  declarations: [DisplayTeamMemberPipe],
  imports: [CommonModule],
  exports: [DisplayTeamMemberPipe],
})
export class PipeModule {}
